export class DownloadFunctions {
  public static getDownloadLinkText = (selectedImages: string[]) => {
    if (selectedImages.length === 1) {
      return `Klicka här för att ladda ned zip-fil med ${selectedImages.length} bild.`;
    }
    return `Klicka här för att ladda ned zip-fil med ${selectedImages.length} bilder.`;
  };

  public static triggerDownload = (document: Document, url: string, imageId: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = `${imageId}.jpg`;
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  public static imageIsSelectedForDownload = (selectedImages: string[], eventId: string, imageId: string): boolean => {
    const result = selectedImages.includes(`${eventId}/${imageId}`);

    return result;
  };
}
